//libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { CheckmarkCircleFill } from '@lyearn/icons';
import { Stack, Typography, TypographyColors } from '@lyearn/ui';

//helpers
import { CompletedProgressLabelProps } from './types';

const LABELS = {
  default: {
    label: 'text-text-white',
    icon: 'icon-white',
  },
  success: {
    label: 'text-text-success',
    icon: 'icon-success',
  },
};

const CompletedProgressLabel: React.FC<CompletedProgressLabelProps> = (props) => {
  const { progress, type = 'default' } = props;
  const { t } = useTranslation();
  const currentLabel = LABELS[type];

  if (!progress || progress !== 100) {
    return null;
  }

  return (
    <Stack alignItems="center" className="mb-16 xs:px-20">
      <CheckmarkCircleFill className="h-22 w-22" fillColorToken={currentLabel.icon} />
      <Typography
        className="ms-8"
        color={currentLabel.label as TypographyColors}
        variant="label-01">
        {t('Common:Completed')}
      </Typography>
    </Stack>
  );
};

export default React.memo(CompletedProgressLabel);
